<template>
    <!-- eslint-disable vue/no-v-html -->
    <ElPopover
        :value="showSuggestion"
        :visible-arrow="false"
        popper-class="patsnap-biz-email-input__suggestion-popover"
        trigger="manual"
        placement="bottom"
    >
        <div
            slot="reference"
            ref="searchInput"
            :class="{
                'patsnap-biz-email-input': true,
                'patsnap-biz-email-input-error': isSomeoneEmailInvalid || service.isEmailError
            }"
            :style="{ width: service.width }"
        >
            <!-- input content -->
            <div
                ref="wrapper"
                :class="{
                    'patsnap-biz-email-input__users-input': true,
                    'patsnap-biz-email-input__users-input--active': isFocus
                }"
                @click="onFocus"
            >
                <!--placeholder-->
                <div
                    v-show="isPlaceholderDisplay"
                    class="patsnap-biz-email-input__users-input__placeholder"
                >
                    {{ service.placeholder }}
                </div>
                <!--输入区域-->
                <div class="patsnap-biz-email-input__users-input__container">
                    <div
                        v-for="(user, index) in userEmailSelectedDisplay"
                        :key="index"
                        :class="{
                            'patsnap-biz-email-input__users-input__item': true,
                            'patsnap-biz-email-input__users-input__item--error': !user.isValid
                        }"
                        @click.stop
                    >
                        <span
                            v-if="user.isValid"
                            :style="{ 'background-color': getSuggestionColor(user.displayLabel.slice(0, 1)) }"
                            :class="{
                                'patsnap-biz-email-input__users-input__item-avator': true,
                                'patsnap-biz-email-input__users-input__item-avator--group': user.type === 'group'
                            }"
                        >
                            {{ user.displayLabel.slice(0, 1).toUpperCase() }}
                        </span>
                        <span class="patsnap-biz-email-input__users-input__item-text">{{ user.displayLabel }}</span>
                        <PtIcon
                            class="patsnap-biz-email-input__users-input__item-close"
                            icon="SolidCloseMedium"
                            @click.stop="onRemoveSelected(user)"
                        />
                    </div>
                    <input
                        v-if="hasSelectedEmail"
                        ref="input"
                        v-model="currentInputing"
                        type="text"
                        class="patsnap-biz-email-input__users-input__invisible-input"
                        spellcheck="false"
                        autocomplete="no"
                        @keyup.188="onInputPush"
                        @keydown.enter.prevent="onInputPush"
                        @blur="onInputBlur"
                        @input="onInputChange"
                    >
                </div>
            </div>

            <div
                v-if="service.isEmailError && service.errorMsg"
                class="patsnap-biz-email-input__error-msg"
            >
                {{ service.errorMsg }}
            </div>
        </div>
        <!--下拉列表-->
        <div
            ref="autoCompleteBody"
            v-clickoutside="closeSuggestList"
            class="patsnap-biz-email-input__suggest"
            :style="`width:${suggestWidth}px`"
            @mousedown.prevent
        >
            <div
                v-if="isLoading"
                class="patsnap-biz-email-input__suggest-loading"
            >
                <PtIcon icon="SolidLoadingBars" />
            </div>
            <div
                v-else-if="nodata"
                class="patsnap-biz-email-input__suggest-nodata"
            >
                {{ nodataDisplayLabel }}
            </div>
            <template v-else>
                <!-- 个人 -->
                <div class="patsnap-biz-email-input__suggest-content">
                    <div
                        v-for="(item, index) in userEmailDisplayList"
                        :key="index"
                        class="patsnap-biz-email-input__suggest-content-item"
                        @click.stop="onSelect(item)"
                    >
                        <slot name="icon" :item="item">
                            <span
                                :style="{ 'background-color': getSuggestionColor(item.firstLatter) }"
                                class="patsnap-biz-email-input__suggest-content-item-avator"
                            >
                                {{ item.firstLatter }}
                            </span>
                        </slot>
                        <div
                            class="patsnap-biz-email-input__suggest-content-item-text"
                        >
                            <p
                                v-if="item.nickname"
                                class="nick-name"
                                v-html="item.nicknameDisplay"
                            />
                            <div class="user-info">
                                <ElPopover
                                    v-if="item.email"
                                    placement="top"
                                    trigger="hover"
                                    :visible-arrow="false"
                                    :open-delay="200"
                                    :close-delay="0"
                                    popper-class="patsnap-biz-email-input__popover"
                                >
                                    <span
                                        slot="reference"
                                        class="user-info-email"
                                        v-html="item.emailDisplay"
                                    />
                                    <p
                                        style="max-width: 500px;"
                                        v-html="item.emailDisplay"
                                    />
                                </ElPopover>
                                <span
                                    v-if="item.mobile_number"
                                    class="user-info-mobile-number"
                                    v-html="item.mobileNumberDisplay"
                                />
                            </div>
                            <div
                                v-if="service.companyMode"
                                class="company-info"
                            >
                                <span
                                    v-if="item.company_name"
                                    class="company-info-name"
                                    v-html="item.companyNameDisplay"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </ElPopover>
</template>

<script>
/* eslint-disable max-len */
import PtIcon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/CloseMedium.svg';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';
import {
    isEmpty, some, debounce, isArray, isBoolean, get, escape,
} from 'lodash';
import clickoutside from 'element-ui/src/utils/clickoutside';
import Popover from 'element-ui/lib/popover';
import {
    checkEmail, checkMobileNumber, getSuggestionColor, getMoblieDesensitization,
} from './utils/index';

export default {
    name: 'PtEmailInput',
    components: {
        PtIcon,
        ElPopover: Popover,
    },
    directives: {
        clickoutside,
    },
    props: {
        service: {
            type: Object,
            default: () => ({}),
            required: true,
        },
    },
    data() {
        return {
            isFocus: false,
            currentInputing: '',
            currentSelected: [],
            isSuggestionDisplay: false,
            isLoading: true,
            userEmailList: [],
            suggestWidth: 0,
            isInputing: false,
        };
    },
    computed: {
        isPlaceholderDisplay() {
            return this.currentSelected.length === 0 && this.currentInputing.length === 0 && !this.isInputing;
        },
        isSomeoneEmailInvalid() {
            return some(this.userEmailSelectedDisplay, (item) => !item.isValid);
        },
        hasSelectedEmail() {
            // 单选模式下，选中则消失
            return !(this.service.selectMode === 'single' && this.currentSelected.length > 0);
        },
        nodata() {
            return this.userEmailDisplayList.length === 0;
        },
        userEmailDisplayList() {
            const inputReg = new RegExp(this.currentInputing, 'i');
            return this.userEmailList.map((user) => {
                const displayLabel = user.nickname || user.email || getMoblieDesensitization(user.mobile_number);
                if (this.service.companyMode && user.person_account) {
                    // eslint-disable-next-line no-param-reassign
                    user.company_name = this.$t('PtEmailInput.personalAccount');
                }
                return {
                    ...user,
                    isValid: true,
                    nicknameDisplay: this.currentInputing && user.nickname
                        ? escape(user.nickname).replace(inputReg, `<b>${this.currentInputing}</b>`)
                        : escape(user.nickname),
                    emailDisplay: this.currentInputing && user.email
                        ? user.email.replace(inputReg, `<b>${this.currentInputing}</b>`)
                        : user.email,
                    mobileNumberDisplay: this.currentInputing && user.mobile_number
                        ? getMoblieDesensitization(user.mobile_number).replace(inputReg, `<b>${this.currentInputing}</b>`)
                        : getMoblieDesensitization(user.mobile_number),
                    companyNameDisplay: this.currentInputing && user.company_name
                        ? escape(user.company_name).replace(inputReg, `<b>${this.currentInputing}</b>`)
                        : escape(user.company_name),
                    displayLabel: displayLabel.replace(inputReg, `<b>${this.currentInputing}</b>`),
                    firstLatter: displayLabel.slice(0, 1).toUpperCase(),
                };
            });
        },
        userEmailSelectedDisplay() {
            return this.currentSelected.map((user) => {
                const displayLabel = user.nickname || user.email || getMoblieDesensitization(user.mobile_number);
                return {
                    ...user,
                    isValid: isBoolean(user.isValid) ? user.isValid : true,
                    displayLabel,
                };
            });
        },
        showSuggestion() {
            return this.isSuggestionDisplay && (this.currentInputing.trim() !== '' || this.service.isAlwaysShowOnFocus);
        },
        nodataDisplayLabel() {
            return this.service.nodataLabel || this.$t('PtEmailInput.nodata');
        },
    },
    watch: {
        currentInputing() {
            this.searchList();
        },
        currentSelected(newSelected) {
            this.service.setSelectedEmail(newSelected);
            if (this.isSomeoneEmailInvalid) this.service.onEmailErrorHandler();
        },
        'service.clearEmail': {
            handler(val) {
                if (val) {
                    if (this.service.setEmailErrorStatus) this.service.setEmailErrorStatus(false);
                    this.currentSelected.splice(0, this.currentSelected.length);
                    this.isInputing = false;
                    this.service.clearEmailSuccess();
                }
            },
            immediate: true,
        },
    },
    created() {
        if (this.service.initSelectedEmail) {
            const { initSelectedEmail } = this.service;
            this.currentSelected = (isArray(initSelectedEmail) ? initSelectedEmail : [initSelectedEmail]).filter((email) => email);
        }
    },
    methods: {
        getSuggestionColor,
        onInputChange(event) {
            const inputData = get(event, 'data');
            this.isInputing = !!inputData;
        },
        async onFocus() {
            if (this.service.companyMode) {
                this.service.setEmailErrorStatus(false);
            }
            if (!this.hasSelectedEmail) return;
            this.$refs.input.focus();
            this.suggestWidth = this.$refs.searchInput.offsetWidth;
            this.isSuggestionDisplay = true;
            this.isFocus = true;
            if (this.service.isAlwaysShowOnFocus && (this.currentInputing.trim() === '' || this.service.companyMode)) {
                await this.searchList();
            }
        },
        onRemoveSelected(user) {
            if (this.service.setEmailErrorStatus) this.service.setEmailErrorStatus(false);
            const index = this.currentSelected.indexOf(user);
            this.currentSelected.splice(index, 1);
            this.isInputing = false;
        },
        onInputBlur() {
            this.isFocus = false;
            this.isSuggestionDisplay = false;
            setTimeout(() => {
                if (this.currentInputing.length) {
                    this.onInputPush();
                }
                if (this.service.companyMode && this.currentInputing.length) {
                    this.service.setEmailErrorStatus(true);
                }
                this.isLoading = true;
            }, 200);
        },
        onInputPush(event) {
            if (this.service.companyMode) return;
            // 中文输入法下，enter keyCode 229
            // 此时不需执行该函数
            if (event && event.keyCode === 229) return;
            let user = {};
            let userIdentifier = '';
            if (event && event.keyCode === 188) {
                userIdentifier = this.currentInputing.slice(0, this.currentInputing.length - 1);
            } else {
                userIdentifier = this.currentInputing;
            }
            userIdentifier = userIdentifier.trim();
            user = {
                email: userIdentifier,
                isValid: checkEmail(userIdentifier) || checkMobileNumber(userIdentifier),
            };
            if (!isEmpty(userIdentifier)) {
                this.currentSelected.push(user);
                this.currentInputing = '';
                this.$refs.input.blur();
            }
        },
        onSelect(item) {
            this.currentSelected.push(item);
            this.currentInputing = '';
            /*
            * firefox在执行完该方法时,input不会触发blur事件，需要手动触发一下
            * chrome可以正常触发blur
            */
            this.$refs.input.blur();
        },
        closeSuggestList() {
            if (this.isFocus) return;
            this.isSuggestionDisplay = false;
            this.isLoading = true;
        },
        // eslint-disable-next-line func-names
        searchList: debounce(async function () {
            if ((!this.currentInputing.trim() && !this.service.isAlwaysShowOnFocus) || !this.isFocus) return;
            await this.getSuggestList();
        }, 300),
        async getSuggestList() {
            this.isLoading = true;
            try {
                const keywords = this.currentInputing.trim();
                if (keywords) {
                    this.userEmailList = await this.service.getEmailList(this.currentInputing || '') || [];
                } else {
                    const list = await this.service.getDefaultList() || [];
                    if (!this.currentInputing.trim()) this.userEmailList = list;
                }
            } catch (err) {
                this.userEmailList = [];
            }
            this.isLoading = false;
        },
    },
};
</script>
